import React from "react";
import PropTypes from "prop-types";

/**
 * Componente StepsButton
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do botão de etapas.
 * @param {string} props.href - O valor href para o link do botão.
 * @param {number} props.step - O número da etapa a ser exibida no botão.
 * @param {boolean} [props.ativo=false] - Um sinalizador indicando se a etapa está ativa ou não.
 * @param {boolean} [props.disabled=false] - Um sinalizador indicando se o botão de etapas é clicável ativa ou não.
 * @returns {ReactElement} O elemento React renderizado que representa o botão de etapas.
 */
function StepsButton({
  children,
  href,
  step,
  ativo = false,
  disabled = false,
  ...props
}) {
  return (
    <li className="nav-item waves-effect waves-light col" {...props}>
      <a
        className={`nav-link steps d-flex align-items-center ${ativo && "active"}`}
        data-bs-toggle="tab"
        href={`#${href}`}
        role="tab"
        id={`${href}Tab`}
        style={{ pointerEvents: disabled ? "none" : "all" }}
      >
        <span className="step-number">{step}.</span>
        <span style={{ fontWeight: 400 }}>{children}</span>
      </a>
    </li>
  );
}

StepsButton.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  ativo: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default StepsButton;
